module.exports = __webpack_public_path__ + "static/media/logout.a5daa943.svg";